import { render, staticRenderFns } from "./print-model.vue?vue&type=template&id=32a99c0b&scoped=true"
import script from "./print-model.vue?vue&type=script&lang=ts"
export * from "./print-model.vue?vue&type=script&lang=ts"
import style0 from "./print-model.vue?vue&type=style&index=0&id=32a99c0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a99c0b",
  null
  
)

export default component.exports